import React, { useEffect, useState } from "react";
import Layout from "../../layout/Layout";
import AdminGrid from "../../components/adminGrid/adminGrid";
import actionBtn from "../../assets/images/actionbtn.png";
import { Button, Popover, Spin } from "antd"; // Import Spin for loading spinner
import { ImWarning } from "react-icons/im";
import { ImBlocked } from "react-icons/im";
import ReviewsModal from "../../components/reviewsModal/reviewsModal";
import WarningModal from "../../components/warningModal/warningModal";
import styles from "./style.module.css";
import deleteIcon from "../../assets/images/delete-icon.png";
import {
  ADMIN,
  getAllAreas,
  getAllCities,
  getAllCountires,
  getAllProvinces,
  getStudents,
} from "../../services/auth";
import { getStudentDetails } from "../../services/auth";
import { toggleBlockStudent } from "../../services/auth";
import { baseUrl } from "../../services/api";
import toast from "react-hot-toast";
import userIcon from "../../assets/images/user-icon-removebg.png";
import BlockedModal from "../../components/blockedModal/blockedModal";
import { AiOutlineSearch } from "react-icons/ai";
import {
  useAreas,
  useCities,
  useCountries,
  useProvinces,
  useStudentDetails,
} from "../../queries";
import { id } from "date-fns/locale";

export const StudentDetails = ({
  cardData,
  onCloseStudentDetails,
  studentDetail,
}) => {
  console.log(studentDetail, "Student Details");
  const {
    data: student,
    isLoading: isLoadingStudent,
    isError: isErrorStudent,
  } = useStudentDetails(studentDetail.id);

  const {
    data: countries,
    isLoading: isLoadingCountries,
    isError: isErrorCountries,
  } = useCountries();

  const {
    data: provinces,
    isLoading: isLoadingProvinces,
    isError: isErrorProvinces,
  } = useProvinces();

  const {
    data: cities,
    isLoading: isLoadingCities,
    isError: isErrorCities,
  } = useCities();

  const {
    data: areas,
    isLoading: isLoadingAreas,
    isError: isErrorAreas,
  } = useAreas();

  const countryName = React.useMemo(() => {
    const list = countries?.data || [];
    const countryId = student?.data?.countryId;
    const isMissingCountryId = countryId === null || countryId === undefined;
    if (isMissingCountryId) return "N/A";
    const country = list.find(({ id }) => id === countryId);
    if (!country) return "N/A";
    const { name } = country;
    return name;
  }, [countries, student]);

  const ProvinceName = React.useMemo(() => {
    const list = provinces?.data || [];
    const provinceId = student?.data?.provinceId;
    const isMissingProvinceId = provinceId === null || provinceId === undefined;
    if (isMissingProvinceId) return "N/A";
    const province = list.find(({ id }) => id === provinceId);
    if (!province) return "N/A";
    const { name } = province;
    return name;
  }, [provinces, student]);

  const CityName = React.useMemo(() => {
    const list = cities?.data || [];
    const cityId = student?.data?.cityId;
    const isMissingCityId = cityId === null || cityId === undefined;
    if (isMissingCityId) return "N/A";
    const city = list.find(({ id }) => id === cityId);
    if (!city) return "N/A";
    const { name } = city;
    return name;
  }, [cities, student]);

  return (
    <div className={`col-md-5 col-sm-12 mt-3 ${styles.mt_3}`}>
      <span className="fw-bold fs_18">Student Detail</span>
      {isLoadingStudent ? (
        <div className="text-center">
          <div
            style={{
              display: "flex",
              paddingLeft: "30px",
              // height: "200px",
              alignItems: "start",
              justifyContent: "center",
            }}
          >
            Loading
          </div>
        </div>
      ) : (
        <div
          className={`mt-3 border border-0 shadow-sm px-4 py-3 rounded-3 text-center ${styles.customBGColor}`}
        >
          <div className="text-right">
            <img
              src={deleteIcon}
              alt="deleteIcon"
              style={{ width: 20, height: 20, cursor: "pointer" }}
              onClick={onCloseStudentDetails}
            />
          </div>
          <div className="d-flex flex-wrap align-items-center justify-content-center">
            {(() => {
              let hasProfilePicture = false;
              const profilePicture = student?.data?.studentMedia?.map(
                (profile) => {
                  if (profile.type === "profilePicture") {
                    hasProfilePicture = true;
                    return (
                      <img
                        key={profile.url}
                        src={profile?.url ? `${baseUrl}${profile?.url}` : ``}
                        alt={`${profile?.fullName}'s profile`}
                        className={`${styles.imgFluid} ${styles.roundedCircle}`}
                      />
                    );
                  }
                  return null;
                }
              );

              return (
                <>
                  {profilePicture}
                  {!hasProfilePicture && (
                    <img
                      src={userIcon}
                      alt="Default User Icon"
                      className={`${styles.imgFluid} ${styles.roundedCircle}`}
                    />
                  )}
                </>
              );
            })()}
            <span className="fs_16 fw-bold px-3 text-center text-sm-start">
              {student?.data?.fullName || "N/A"}
              {""}
              <div className="fs_14 text-secondary py-1">
                {student?.data?.level || "N/A"}
                {""}
              </div>
            </span>
          </div>
          <hr className="text-secondary" />
          <p className="prodetail text-left fs_16 fw-bold">Profile Detail</p>
          <div className="row text-left">
            <div className="col-5">
              <span className="fs_12 text-secondary">Full Name</span>
            </div>
            <div className="col-7">
              <span className="fs_12 text-secondary">Father Name</span>
            </div>
          </div>
          <div className="row text-left">
            <div className="col-5">
              <span className="fs_14 fw-bold">
                {student?.data?.fullName || "N/A"}
              </span>
            </div>
            <div className="col-7">
              <span className="fs_14 fw-bold">
                {student?.data?.fatherName || "N/A"}
              </span>
            </div>
          </div>
          <div className="row text-left pt-3">
            <div className="col-5">
              <span className="fs_12 text-secondary">Phone Number</span>
            </div>
          </div>
          <div className="row text-left">
            <div className="col-5">
              <span className="fs_14 fw-bold">
                {student?.data?.contactNumber || "N/A"}
              </span>
            </div>
          </div>
          <div className="row text-left pt-3">
            <div className="col-7">
              <span className="fs_12 text-secondary">Email Address :</span>
            </div>
          </div>
          <div className="row text-left">
            <div className="col-7">
              <span className={`fs_14 fw-bold ${styles.text_one_line}`}>
                {student?.data?.email || "N/A"}
              </span>
            </div>
          </div>
          <div className="row text-left pt-3">
            <div className="col-12">
              <span className="fs_12 text-secondary invisible">
                Email Address
              </span>
            </div>
            <div className="col-12">
              <span className="fs_14 fw-bold invisible">
                usmankhalid@gmail.com
              </span>
            </div>
          </div>
          <hr className="text-secondary" />
          <div className="row text-left">
            <div className="col-5">
              <span className="fs_12 text-secondary">Country</span>
            </div>
            <div className="col-7">
              <span className="fs_12 text-secondary">Province</span>
            </div>
          </div>
          <div className="row text-left">
            <div className="col-5">
              <span className="fs_14 fw-bold">
                {isLoadingCountries ? "..." : countryName}
                {isErrorCountries && "data not found"}
              </span>
            </div>
            <div className="col-7">
              <span className="fs_14 fw-bold">
                {isLoadingProvinces ? "..." : ProvinceName}
                {isErrorProvinces && "data not found"}
              </span>
            </div>
          </div>
          <div className="row text-left pt-3">
            <div className="col-12">
              <span className="fs_12 text-secondary">Present Address</span>
            </div>
            <div className="col-12">
              <span className="fs_14 fw-bold">
                {isLoadingCities ? "..." : CityName}
                {isErrorCities && "data not found"}
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
